import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db} from '../LoginComp/firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

import './body.css';

function Body() {
  

  const banners = ["/banner1.png", "/banner1.png"];

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % banners.length);
    }, 5000); // change every 5 seconds

    return () => clearInterval(interval);
  }, []);


  const categories = [
    { name: "Researches", path: "/researchpaper" },
    { name: "E-Books", path: "/ebooks" },
    { name: "Articles", path: "/journalarticle" },
    { name: "Clinical Resources", path: "/clinicalresource" },
    { name: "Theses", path: "/thesis" },
  ];


  const [showPopup, setShowPopup] = useState(true);

  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);  // Number of items per page



  const [searchQuery, setSearchQuery] = useState(""); //general search bar
  const [books, setBooks] = useState([]);

  useEffect(() => {
    const fetchResources = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "mainresources"));
        const resourceData = await Promise.all(
          querySnapshot.docs.map(async (doc) => {
            const data = doc.data();
  
 
  
            return {
              ...data,
              pdfUrl: data.pdfFileURL

            };
          })
        );
  
        setResources(resourceData);
      } catch (error) {
        console.error("Error fetching resources: ", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchResources();
  }, []);

  // if (loading) {
  //   return <div>Loading resources...</div>;
  // }

  // Pagination Logic
  const indexOfLastResource = currentPage * itemsPerPage;
  const indexOfFirstResource = indexOfLastResource - itemsPerPage;
  const currentResources = resources.slice(indexOfFirstResource, indexOfLastResource);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const totalPages = Math.ceil(resources.length / itemsPerPage);





const searchBooks = async () => {
  if (!searchQuery.trim()) return;
  setLoading(true);

  try {
    const booksRef = collection(db, "mainresources");

    // Convert search query to lowercase for case-insensitive search
    const lowerCaseQuery = searchQuery.toLowerCase();

    // Search using 'array-contains-any' (for words matching searchKeywords array)
    const q = query(booksRef, where("searchKeywords", "array-contains-any", lowerCaseQuery.split(" ")));

    const snapshot = await getDocs(q);
    const results = snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));

    setBooks(results);
  } catch (error) {
    console.error("Error fetching books:", error);
  }

  setLoading(false);
};







// State to hold search input values
const [searchParams, setSearchParams] = useState({
  searchKeywords: "",
  author: "",
  publicationYearFrom: "",
  publicationYearTo: "",
  description: "",

});

// State for search results & pagination
const [results, setResults] = useState([]);
const [currentShowPage, setCurrentShowPage] = useState(1);
const resultsPerPage = 2; // Max 2 resources per page

// Handle input changes
const handleInputChange = (e) => {
  setSearchParams({
    ...searchParams,
    [e.target.name]: e.target.value,
  });
};





// Function to fetch filtered articles
const fetchFilteredArticles = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const resourceRef = collection(db, "mainresources");
  let conditions = [];

 // Dynamically add filters if the user provided values
 if (searchParams.searchKeywords) {
  conditions.push(where("searchKeywords", "array-contains", searchParams.searchKeywords));
}
  if (searchParams.author) {
    conditions.push(where("author", "==", searchParams.author));
  }
  if (searchParams.publicationYearFrom) {
    conditions.push(where("publication_year", ">=", parseInt(searchParams.publicationYearFrom)));
  }
  if (searchParams.publicationYearTo) {
    conditions.push(where("publication_year", "<=", parseInt(searchParams.publicationYearTo)));
  }

  try {
    let q;

    if (conditions.length > 1) {
      // If multiple conditions exist, we must index them properly in Firestore
      q = query(resourceRef, ...conditions);
    } else if (conditions.length === 1) {
      // Single condition case
      q = query(resourceRef, conditions[0]);
    } else {
      // If no filters applied, fetch all resources
      q = query(resourceRef);
    }

    const querySnapshot = await getDocs(q);
    const articles = querySnapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    }));

    setResults(articles);
    setCurrentShowPage(1); // Reset pagination when search updates
  } catch (error) {
    console.error("Error fetching filtered articles:", error);
  }
};




// Calculate total pages
const totalShowPages = Math.ceil(results.length / resultsPerPage);
const startIndex = (currentPage - 1) * resultsPerPage;
const paginatedResults = results.slice(startIndex, startIndex + resultsPerPage);

// Corrected Pagination Function
const Paginate = (pageNumber) => {
  if (pageNumber >= 1 && pageNumber <= totalShowPages) {
    setCurrentPage(pageNumber);
  }
};




  return (

<div className="home-page">

 <section
      className="hero-banner"
      style={{
        backgroundImage: `url(${banners[index]})`,
      }}
    >
      <div className="hero-overlay" />

      <div className="hero-content">

      </div>
    </section>

        {showPopup && (
          <div className="popup">
            <button className="popup-close" onClick={() => setShowPopup(false)}>×</button>
            <div className="popup-content">
              <img 
                src="/getreg.jpg" 
                alt="Community Contribution" 
                className="popup-image" 
              />
          <h3>Contribute and earn points! <img className='img-stars-contribute' src="stars.png" alt="Rewards Icon" /></h3>
          <p>Share your expertise in eye care by contributing articles, research, and other valuable resources. Earn points for your contributions and redeem them for exclusive access to premium content and opportunities.</p>
              <Link to="/signup">
                <button className="popup-register">Sign Up</button>
              </Link>
            </div>
          </div>
        )}

      <main className="main-content">


        






        <section className="search-section">
            <h2>Search the Library</h2>
          <div className="search-bar-container">



        {/*general search*/}
        
    <div className="search-container">

  <div className="search-bar">

    <input
      type="text"
      placeholder="Search by title, author, or specific area"
      className="search-input"
      value={searchQuery}
      onChange={(e) => setSearchQuery(e.target.value)}
    />

    <button className="search-button" onClick={searchBooks}>
      Search
    </button>

  </div>

  {loading && <p className="loading-text">Loading...</p>}

  <div className="results">

    {books.length > 0 ? (

      books.map((book) => (

        <div key={book.id} className="article-item">

          {book.coverImageURL && (
            <img
              src={book.coverImageURL}
              alt={book.title}
              className="book-cover-image"
            />
          )}

          <div className="article-content">

            <h4>{book.title}</h4>

            <div className="book-meta-data">

              {book.author && (
                <p>
                  <strong>Author:</strong> {book.author}
                </p>
              )}

              {book.publication_year && (
                <p>
                  <strong>Year:</strong> {book.publication_year}
                </p>
              )}

              {book.isbn && (
                <p>
                  <strong>ISBN:</strong> {book.isbn}
                </p>
              )}

            </div>

            {book.description && (
              <p className="book-description">
                {book.description}
              </p>
            )}

            {book.pdfFileURL && (
              <a
                href={book.pdfFileURL}
                target="_blank"
                rel="noopener noreferrer"
                className="read-article-btn"
              >
                Read Resource
              </a>
            )}

          </div>

        </div>

      ))

    ) : (

      !loading && (
        <div className="no-results-found">
          <h3>No Results Found</h3>
          <p>Try searching with different keywords or author names.</p>
        </div>
      )

    )}

  </div>

</div>


        <section>
          <div className="advanced-options">
            <h3>Advanced Search</h3>
            <form className="advanced-search-form" onSubmit={fetchFilteredArticles}>
              <input type="text" name="searchKeywords" placeholder="Keywords" className="search-input" value={searchParams.searchKeywords} onChange={handleInputChange} />
              <input type="text" name="author" placeholder="Author" className="search-input" value={searchParams.author} onChange={handleInputChange} />
              <input type="number" name="publicationYearFrom" placeholder="Publication Year From" className="search-input" value={searchParams.publicationYearFrom} onChange={handleInputChange} />
              <input type="number" name="publicationYearTo" placeholder="Publication Year To" className="search-input" value={searchParams.publicationYearTo} onChange={handleInputChange} />

              <button type="submit" className="search-button">Search</button>
            </form>


            {/* Display Search Results */}
 {/* Display Search Results */}
<div className="search-results">

  {paginatedResults.length > 0 ? (

    paginatedResults.map((book) => (

      <div key={book.id} className="article-item">

        {book.coverImageURL && (
          <img
            src={book.coverImageURL}
            alt={book.title}
            className="book-cover-image"
          />
        )}

        <div className="article-content">

          <h4>{book.title}</h4>

          <div className="book-meta-data">

            {book.author && (
              <p>
                <strong>Author:</strong> {book.author}
              </p>
            )}

            {book.publication_year && (
              <p>
                <strong>Year:</strong> {book.publication_year}
              </p>
            )}

            {book.isbn && (
              <p>
                <strong>ISBN:</strong> {book.isbn}
              </p>
            )}

          </div>

          {book.description && (
            <p className="book-description">
              {book.description}
            </p>
          )}

          {book.pdfFileURL && (
            <a
              href={book.pdfFileURL}
              target="_blank"
              rel="noopener noreferrer"
              className="read-article-btn"
            >
              Read Resource
            </a>
          )}

        </div>

      </div>

    ))

  ) : (

    <p>No results found.</p>

  )}

</div>

            {/* Pagination */}
            {totalShowPages > 1 && (
              <div className="pagination-container">
                <button
                  className="pagination-button"
                  onClick={() => Paginate(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  Previous
                </button>
                {Array.from({ length: totalShowPages }, (_, index) => (
                  <button
                    key={index + 1}
                    className={`pagination-button ${currentPage === index + 1 ? "active" : ""}`}
                    onClick={() => Paginate(index + 1)}
                  >
                    {index + 1}
                  </button>
                ))}
                <button
                  className="pagination-button"
                  onClick={() => Paginate(currentPage + 1)}
                  disabled={currentPage === totalShowPages}
                >
                  Next
                </button>
              </div>
            )}
          </div>
        </section>

  </div>
</section>


      <section>
        <div className="category-container">
          {categories.map((category) => (
            <Link key={category.name} to={category.path} className="category-button">
              {category.name}
            </Link>
          ))}
        </div>
      </section>


        <section id="collections" className="collections-section">
          <h2>Our Collections</h2>
          <div className="collections-grid">
            <div className="collection-item">
              <h3>Articles</h3>
              <p>Access the latest peer-reviewed journals in eye care and vision science.</p>
            </div>
            <div className="collection-item">
              <h3>E-Books</h3>
              <p>Explore a wide range of textbooks and reference materials.</p>
            </div>
            <div className="collection-item">
              <h3>Researches</h3>
              <p>Explore a wide range of researches and reference materials.</p>
            </div>
            <div className="collection-item">
              <h3>Clinical Resource</h3>
            <p>Explore a collection of real-world clinical resources designed to enhance your learning experience and deepen your understanding of practical medical applications.</p>
            </div>
            <div className="collection-item">
              <h3>Theses and Dissertations</h3>
              <p>This collection contains optometry and vision science theses and dissertations submitted by students as part of their academic programs. These works represent original research and scholarship across a variety of disciplines.</p>
            </div>
            <div className="collection-item">
              <h3>Special Collections</h3>
              <p>Our Special Collections house a diverse range of unique and rare materials related to optometry, including historical texts, instruments, photographs, and archival documents. These collections offer valuable insights into the history and development of eye care and vision science.</p>
            </div>
          </div>
        </section>
        
      </main>

<section className="main-resources-section">
  <div className="main-resources-container">
    <h3 className="main-resources-header">Resources</h3>
    <ul className="resource-list">
      {currentResources.map((resource, index) => (
        <li key={index} className="resource-item">
          {resource.imgUrl && (
            <img
              src={resource.imgUrl}
              alt={resource.title}
              className="resource-image"
            />
          )}
          <div className="resource-details">
            <h4 className="resource-title">{resource.title}</h4>
            <p className="resource-description">
              {resource.author} | {resource.publication_year} | {resource.isbn} | {resource.description}
            </p>
            <a
              href={resource.pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="resource-link"
            >
              Read More
            </a>
          </div>
        </li>
      ))}
    </ul>

    {/* Pagination */}
    <div className="pagination-container">
      <button
        className="pagination-button"
        onClick={() => paginate(currentPage - 1)}
        disabled={currentPage === 1}
      >
        Previous
      </button>
      {Array.from({ length: totalPages }, (_, index) => (
        <button
          key={index + 1}
          className={`pagination-button ${currentPage === index + 1 ? 'active' : ''}`}
          onClick={() => paginate(index + 1)}
        >
          {index + 1}
        </button>
      ))}
      <button
        className="pagination-button"
        onClick={() => paginate(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  </div>
</section>





    </div>
  );
}

export default Body;